import { render, staticRenderFns } from "./CardWishlistExp.vue?vue&type=template&id=7932b908&"
import script from "./CardWishlistExp.vue?vue&type=script&lang=js&"
export * from "./CardWishlistExp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports